import { render, staticRenderFns } from "./StaffsAdmin.vue?vue&type=template&id=20c23e4b&"
import script from "./StaffsAdmin.vue?vue&type=script&lang=js&"
export * from "./StaffsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports